import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import PlayerCard from "./player-card";

// Sample card shown in the upgrade modal, matching the Figma
// "Unsubscribed User – Upgrade Modal" frame. Not real athlete data.
const SAMPLE_CARD = {
  firstName: "Peyton",
  lastName: "Higginson",
  position: "Quarterback",
  positionRank: 1,
  positionScore: 96,
  school: "Salem Hills High School",
  state: "UT",
  graduationYear: 2026,
  measurements: {
    weight: { value: 180, score: 76 },
    height: { feet: 6, inches: 2.75, score: 96 },
    wingspan: { feet: 6, inches: 5, score: 92 },
    hand: { value: 10.188, score: 92 },
    foot: { value: 12, score: 96 },
  },
};

const INCLUDED_FEATURES = [
  "Customize the information shown on your card",
  "Showcase your position score and measurements",
  "Choose which performance results to share",
  "Add a QR code linking to your public profile",
  "Download or share directly to social media",
];

export default function ShareProfileCardUpgradeModal({
  open,
  onClose,
  onStartFreeTrial,
  onSubscribe,
  showStartFreeTrial = true,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="relative w-full max-w-3xl rounded-lg bg-white p-6 shadow-xl sm:p-8">
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
          >
            <FontAwesomeIcon icon={faXmark} className="h-5 w-5" />
          </button>

          <DialogTitle className="text-xl font-bold text-gray-950">
            Share Your Profile Card
          </DialogTitle>
          <p className="mt-1 max-w-xl text-sm text-gray-600">
            Create a custom athlete card and share your performance with coaches
            and recruiters.
          </p>

          <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:items-start">
            <div className="flex-1 overflow-hidden rounded-xl h-[220px] sm:h-[250px] lg:h-[200px] xl:h-[250px]">
              <div className="origin-top-left scale-[0.45] sm:scale-[0.62] lg:scale-[0.5] xl:scale-[0.62]">
                <PlayerCard card={SAMPLE_CARD} />
              </div>
            </div>

            <div className="flex-1">
              <h3 className="text-sm font-bold text-gray-950">
                Included with your subscription
              </h3>
              <ul className="mt-3 flex flex-col gap-3">
                {INCLUDED_FEATURES.map((feature) => (
                  <li key={feature} className="flex items-start gap-2">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green-600"
                    />
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 bg-white px-6 py-3 text-sm text-gray-600 transition hover:bg-gray-50 sm:min-w-40"
            >
              Maybe Later
            </button>

            {showStartFreeTrial && onStartFreeTrial && (
              <button
                type="button"
                onClick={onStartFreeTrial}
                className="rounded-md border border-red-200 bg-white px-6 py-3 text-sm text-red-500 transition hover:bg-red-50 sm:min-w-40"
              >
                Start Free Trial
              </button>
            )}

            {onSubscribe && (
              <button
                type="button"
                onClick={onSubscribe}
                className="rounded-md bg-red-500 px-6 py-3 text-sm text-white transition hover:bg-red-600 sm:min-w-40"
              >
                Subscribe Now
              </button>
            )}
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
